define("DC.QuantityPricing.QtyPrice", [
  "DC.QuantityPricing.QtyPrice.View",
  "Cart.AddToCart.Button.View",
  "ProductDetails.Full.View",
  "ProductDetails.Base.View",
  "Facets.ItemCell.View",
  "ProductLine.Stock.View",
  "GlobalViews.StarRating.View",
  "Utils",
  "Product.Model",
  "Cart.QuickAddToCart.View",
  "ProductLine.StockDescription.View",
  "Backbone.CollectionView",
  "Configuration",
  "ProductViews.Option.View",
  "ProductDetails.QuickView.View",
  "DC.Confirmation.View",
  "QuickAdd.View",
  "Cart.Detailed.View",
  "dc_quantitypricing_cartdetailed.tpl",
  "Cart.Confirmation.Helpers"
], function (
  QtyPriceView,
  CartAddToCartButtonView,
  ProductDetailsFullView,
  ProductDetailsBaseView,
  FacetsItemCellView,
  ProductLineStockView,
  GlobalViewsStarRating,
  Utils,
  ProductModel,
  CartQuickAddToCartView,
  ProductLineStockDescriptionView,
  BackboneCollectionView,
  Configuration,
  ProductViewsOptionView,
  ProductDetailsQuickViewView,
  DCConfirmationView,
  QuickAddView,
  CartDetailedView,
  dc_quantitypricing_cartdetailed_tpl,
  Cart_Confirmation_Helpers
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent("Layout");
      var pdp = container.getComponent("PDP");
      var plp = container.getComponent("PLP");

      var cart = container.getComponent('Cart');

      console.log("Cart_Confirmation_Helpers", Cart_Confirmation_Helpers)

      Cart_Confirmation_Helpers.showCartConfirmation = function showCartConfirmation(cart_promise, line, application) {
              // Available values are: goToCart, showMiniCart and showCartConfirmationModal
              console.log('TEST')
              // console.log("=== showCartConfirmation DEBUG ===");
              // console.log("line:", line);
              // console.log("line quantity:", line.get ? line.get("quantity") : "no get method");
              // console.log("addToCartBehavior:", Configuration.get('addToCartBehavior', 'showCartConfirmationModal'));
 
              var hasFreight = false;
              var item = line.get ? line.get("item") : null;
              if (item) {
                  var selectedIndex = parseInt(line.get("selectedIndex") || 0, 10);
                  var baseTiersString = item.get("custitem_base_price_tiers");
                  var saleTiersString = item.get("custitem_sale_price_tiers");

                  if (baseTiersString || saleTiersString) {
                      var tierPairs = (baseTiersString || saleTiersString).split("|");
                      if (selectedIndex >= 0 && selectedIndex < tierPairs.length) {
                          var freightValue = item.get("custitem_bags_freight" + (selectedIndex + 1));
                          if (freightValue) {
                              hasFreight = true;
                          }
                      }
                  }
              }

              this['_' + Configuration.get('addToCartBehavior', 'showCartConfirmationModal')](
                  cart_promise,
                  line,
                  application
              );
      
              if (hasFreight) {
                  cart_promise.done(function () {
                      var $amount = jQuery('.cart-confirmation-modal-value');
                      if ($amount.length && $amount.text().indexOf('(+FRT)') === -1) {
                          $amount.text($amount.text() + ' (+FRT)');
                      }
                  });
              }
              
              const layout = application.getLayout();
              cart_promise.fail(function(error) {
                  let output_message = '';
                  let error_object = { errorCode: 'UNKNOWN' };
                  let error_message = '';
      
                      // console.log('Error', error);
                  if (error) {
                      if (error.responseJSON) {
                          error_object = error.responseJSON;
                          error_message  = layout.parseErrorMessage(error);
                      } else if (_.isString(error)) {
                          // Error came from Frontend ExtLayer
                          error_object.errorCode = 'ERR_EXT_CANCELED_OPERATION';
                          error_message = error;
                      }
                  }
      

                  console.log('Error', error);

                  // if the error was caused by an extension canceling the operation,
                  // then show the error message from the back-end
                  if (error_object.errorCode === 'ERR_EXT_CANCELED_OPERATION' && error_message) {
                      output_message = error_message;
                  } else if((error?.errorMessage)?.indexOf('Please select:') !== -1){
                      output_message = Utils.translate(
                          error.errorMessage
                      );
                  }  else{
                      output_message = Utils.translate(
                          'Sorry, there is a problem with this Item and can not be purchased at this time. Please check back later.'
                      );
                  }
                  layout.showErrorInModal(output_message);
              });
          };
          if (cart) {
            cart.cancelableOn('beforeAddLine', function (data) {
                var deferred = jQuery.Deferred();
                try {
                    var line = data.line || data;
                    var options = line.options || [];
                    console.log('OPTIONS:', options);
                    // ✅ Filter only real item options (ignore system ones)
                    var itemOptions = options.filter(function(opt) {
                        return opt.itemOptionId && opt.itemOptionId !== '';
                    });
                    if (!itemOptions.length) {
                        // No real options → allow
                        return deferred.resolve();
                    }
                    // 🔥 Check if any item option is missing value
                    var missingOption = itemOptions.find(function(opt) {
                        return !opt.value || !opt.value.internalid;
                    });
                    if (missingOption) {
                        console.log('Missing option:', missingOption);
                        return deferred.reject({
                            errorMessage: 'Please select: ' + (missingOption.label || 'required option')
                        });
                    }
                    // ✅ All good
                    return deferred.resolve();
                } catch (e) {
                    console.error('Validation error:', e);
                    return deferred.reject({
                        errorMessage: 'Validation failed. Please try again.'
                    });
                }
            });
        }


      jQuery("body").on("click", '[name="custcol_ink_color"]', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var value = jQuery(e.target).val();
        pdp.setOption("custcol_ink_color", value);
      });
      if (layout) {
        _.extend(ProductDetailsQuickViewView.prototype, {
          childViews: _.extend(
            {},
            ProductDetailsBaseView.prototype.childViews,
            {
              "Cstm.Quantity.Pricing": function () {
                console.log("container", container);
                return new QtyPriceView({
                  context: "PDQ",
                  iteminfo: this.model.get("item"),
                  container: container,
                  model: this.model,
                });
              },
            }
          ),
        });
        //
        _.extend(CartDetailedView.prototype, {
          template: dc_quantitypricing_cartdetailed_tpl,
        });
        //
        _.extend(QuickAddView.prototype, {
          parsePriceTiers: function (tiersString) {
            if (!tiersString) return [];
            var tiers = [];
            var tierPairs = tiersString.split("|");
            _.each(tierPairs, function (pair, index) {
              var parts = pair.split(":");
              if (parts.length === 3) {
                // Changed from 2 to 3
                var qty = parseInt(parts[0], 10);
                var unitPrice = parseFloat(parts[1]);
                var totalPrice = parseFloat(parts[2]); // Added total price

                // Create the tier object
                var tier = {
                  minimumquantity: qty,
                  price: unitPrice, // Unit price
                  totalPrice: totalPrice, // Added total price field
                };

                // Calculate maximum quantity based on the next tier's minimum quantity
                if (index < tierPairs.length - 1) {
                  var nextParts = tierPairs[index + 1].split(":");
                  if (nextParts.length === 3) {
                    // Changed from 2 to 3
                    var nextMinQty = parseInt(nextParts[0], 10);
                    tier.maximumquantity = nextMinQty;
                  }
                }

                tiers.push(tier);
              }
            });

            // Sort by quantity
            return _.sortBy(tiers, function (tier) {
              return tier.minimumquantity;
            });
          },

          buildCombinedPriceSchedule: function () {
            var self = this;
            var combinedSchedule = [];
            // Get base and sale price schedules
            var baseSchedule = this.priceLevels.base.priceschedule || [];
            var saleSchedule = this.priceLevels.sale.priceschedule || [];
            // Check if we have both price levels
            var hasBothPriceLevels =
              baseSchedule.length > 0 && saleSchedule.length > 0;
            // If we have both, create a combined schedule
            if (hasBothPriceLevels) {
              // Create a map of quantities to make matching easier
              var quantityMap = {};

              // Add all base prices to the map
              _.each(baseSchedule, function (tier, index) {
                var qty = tier.minimumquantity;
                if (!quantityMap[qty]) {
                  quantityMap[qty] = {
                    minimumquantity: qty,
                    maximumquantity: tier.maximumquantity,
                    basePrice: tier.price,
                    base_price_formatted: "$" + (tier.price * qty).toFixed(2),
                    hasSalePrice: false,
                  };
                }
              });

              // Add all sale prices to the map
              _.each(saleSchedule, function (tier, index) {
                var qty = tier.minimumquantity;
                if (quantityMap[qty]) {
                  // Update existing entry with sale price
                  quantityMap[qty].price = tier.price;
                  quantityMap[qty].price_formatted =
                    "$" + (tier.price * qty).toFixed(2);
                  quantityMap[qty].hasSalePrice = true;

                  // Calculate discount percentage
                  if (quantityMap[qty].basePrice > 0) {
                    var discount =
                      ((quantityMap[qty].basePrice - tier.price) /
                        quantityMap[qty].basePrice) *
                      100;
                    quantityMap[qty].discountPercentage = Math.round(discount);
                  }
                } else {
                  // Create new entry with only sale price
                  quantityMap[qty] = {
                    minimumquantity: qty,
                    maximumquantity: tier.maximumquantity,
                    price: tier.price,
                    price_formatted: "$" + (tier.price * qty).toFixed(2),
                    hasSalePrice: false,
                  };
                }
              });

              // Apply freight indicators and format display text
              _.each(quantityMap, function (tier, qty) {
                // Calculate maximum quantity based on next tier
                var allQuantities = _.keys(quantityMap)
                  .map(function (q) {
                    return parseInt(q, 10);
                  })
                  .sort(function (a, b) {
                    return a - b;
                  });
                var currentIndex = allQuantities.indexOf(tier.minimumquantity);
                if (currentIndex < allQuantities.length - 1) {
                  tier.maximumquantity = allQuantities[currentIndex + 1] - 1;
                }

                // Try to match index with freight indicator fields
                var tierIndex = _.findIndex(baseSchedule, function (baseTier) {
                  return baseTier.minimumquantity === tier.minimumquantity;
                });

                if (tierIndex >= 0) {
                  var freightValue = self.item.get(
                    "custitem_bags_freight" + (tierIndex + 1)
                  );
                  if (freightValue) {
                    tier.hasFreight = true;

                    if (tier.hasSalePrice) {
                      // tier.price_formatted += ' (+FRT)'; //new commented code
                      tier.base_price_formatted += " (+FRT)";
                    } else {
                      tier.price_formatted += " (+FRT)";
                    }
                  }
                }

                // Create display text for dropdown
                if (tier.hasSalePrice) {
                  tier.display_text =
                    tier.minimumquantity +
                    " - Price: " +
                    tier.price_formatted +
                    " (was " +
                    tier.base_price_formatted +
                    ")";
                } else {
                  tier.display_text =
                    tier.minimumquantity + " - Price: " + tier.price_formatted;
                }
              });

              // Convert map back to array and sort by quantity
              combinedSchedule = _.map(quantityMap, function (item) {
                return item;
              });

              combinedSchedule = _.sortBy(combinedSchedule, "minimumquantity");
            } else {
              // If only one price level exists, use it
              var activeSchedule =
                baseSchedule.length > 0 ? baseSchedule : saleSchedule;
              var isBasePriceActive = baseSchedule.length > 0;

              combinedSchedule = _.map(activeSchedule, function (tier, index) {
                var result = {
                  minimumquantity: tier.minimumquantity,
                  maximumquantity: tier.maximumquantity,
                  hasSalePrice: false,
                };

                // Calculate maximum quantity for this tier
                if (index < activeSchedule.length - 1) {
                  result.maximumquantity =
                    activeSchedule[index + 1].minimumquantity - 1;
                }

                if (isBasePriceActive) {
                  result.basePrice = tier.price;
                  result.price = tier.price;
                } else {
                  result.price = tier.price;
                }

                // Apply freight indicators
                var freightValue = self.item.get(
                  "custitem_bags_freight" + (index + 1)
                );
                result.hasFreight = !!freightValue;

                // Format prices
                result.price_formatted =
                  "$" + (tier.price * tier.minimumquantity).toFixed(2);
                if (freightValue) {
                  result.price_formatted += " (+FRT)";
                }

                // Create display text for dropdown (no "was" text since only one price level)
                result.display_text =
                  result.minimumquantity +
                  " - Price: " +
                  result.price_formatted;

                return result;
              });
            }
            return combinedSchedule;
          },
          events: {
            'click [data-type="quick-add-reset"]': "resetHandle",
            "submit form": "saveForm",
            'change [data-action="qty-pricing-change"]': "changeQtyPricing",
          },
          //
          changeQtyPricing: function (e) {
            this.selectedIndex = this.$(e.currentTarget).val();
            this.model.set("selectedIndex", this.$(e.currentTarget).val());
            var selectedTier = this.combinedPriceSchedule[this.selectedIndex];
            if (selectedTier && selectedTier.minimumquantity) {
              this.model.set("quantity", selectedTier.minimumquantity);
            }
          },
          onItemSelected: function (result) {
            var product = result.selectedItem;
            let item;
            if (product) {
              item = product.getItem();
              this.item = item;
              this.model.set("item", item);
              this.model.set("quickaddSearch", item.get("_name"));
              this.model.set("selectedProduct", product);
              this.selectedIndex = 0;
              this.model.set("selectedIndex", 0);
              var baseTiersString = this.item.get("custitem_base_price_tiers");
              var saleTiersString = this.item.get("custitem_sale_price_tiers");
              // Log raw values for debugging
              console.log("Base price tiers string:", baseTiersString);
              console.log("Sale price tiers string:", saleTiersString);
              this.priceLevels = {
                base: {
                  priceschedule: this.parsePriceTiers(baseTiersString),
                },
                sale: {
                  priceschedule: this.parsePriceTiers(saleTiersString),
                },
              };
              // Log parsed price levels
              console.log("Parsed price levels:", this.priceLevels);
              // Build combined price schedule
              this.combinedPriceSchedule = this.buildCombinedPriceSchedule();
              var priceSchedule =
                this.model &&
                this.model.get("item") &&
                this.model.get("item").get("onlinecustomerprice_detail")
                  ? this.model.get("item").get("onlinecustomerprice_detail")
                      .priceschedule
                  : [];
              var self = this;
              _.map(priceSchedule, function (price, index) {
                var freightMessage = self.model
                  .get("item")
                  .get("custitem_bags_freight" + (index + 1))
                  ? " (+FRT)"
                  : ""; //as index starts from 0
                price.price_formatted =
                  "$" +
                  (price.price * price.minimumquantity).toFixed(2) +
                  freightMessage;
                return price;
              });
              if (priceSchedule) {
                console.log(
                  "priceSchedule[this.selectedIndex]",
                  priceSchedule[this.model.get("selectedIndex")]
                );
                var cprice = priceSchedule[this.selectedIndex];
                this.model.set("quantity", cprice.minimumquantity);
              }
              // this.setDefaultQuantity(item.get('_minimumQuantity', true), item.get('internalid'));
              // // this.$('[name="quantity"]').focus();
              // //this.selectAll();
              var minimum_quantity = item.get("_minimumQuantity", true);
              if (minimum_quantity > 1) {
                this.$('[data-type="minimum-quantity"]').html(
                  Utils.translate("Minimum of $(0) required", minimum_quantity)
                );
              }
              this.$('[data-validation-error="block"]').remove();

              this.priceSchedule = this.item.get(
                "onlinecustomerprice_detail"
              )?.priceschedule;
              var activeTier = null;
              if (
                this.combinedPriceSchedule &&
                this.combinedPriceSchedule[this.selectedIndex]
              ) {
                activeTier = this.combinedPriceSchedule[this.selectedIndex];
              }
              console.log("getContext: Active Tier: ", activeTier);
              var hasBothPriceLevels =
                this.priceLevels &&
                this.priceLevels.base.priceschedule.length > 0 &&
                this.priceLevels.sale.priceschedule.length > 0;
              console.log("getContext: hasBothPriceLevels", hasBothPriceLevels);
              var isSaleActive =
                hasBothPriceLevels && activeTier && activeTier.hasSalePrice;
              console.log("getContext: isSaleActive", isSaleActive);
              var priceToDisplay = "";
              var unitPrice = "";
              var basePriceToDisplay = "";
              var baseUnitPrice = "";
              var discountPercentage = 0;
              if (activeTier) {
                // Sale price (or only price if no sale)
                if (activeTier.price) {
                  unitPrice = "$" + activeTier.price.toFixed(4);
                  priceToDisplay =
                    "$" +
                    (activeTier.price * activeTier.minimumquantity).toFixed(2);

                  // Add freight indicator if applicable
                  if (activeTier.hasFreight) {
                    priceToDisplay += " (+FRT)";
                  }

                  // Add "was" price if sale price exists
                  if (activeTier.hasSalePrice && activeTier.basePrice) {
                    var basePriceForDisplay =
                      "$" +
                      (
                        activeTier.basePrice * activeTier.minimumquantity
                      ).toFixed(2);
                    if (activeTier.hasFreight) {
                      basePriceForDisplay += " (+FRT)";
                    }

                    if (priceToDisplay.indexOf(" (+FRT)") !== -1) {
                      priceToDisplay = priceToDisplay.replace(" (+FRT)", "");
                    }

                    priceToDisplay += " (was " + basePriceForDisplay + ")";
                  }

                  console.log(
                    "getContext: If Sale price is active tier: ",
                    priceToDisplay
                  );
                }

                // Base price (if sale exists)
                if (activeTier.hasSalePrice && activeTier.basePrice) {
                  baseUnitPrice = "$" + activeTier.basePrice.toFixed(4);
                  basePriceToDisplay =
                    "$" +
                    (activeTier.basePrice * activeTier.minimumquantity).toFixed(
                      2
                    );

                  // Add freight indicator if applicable
                  if (activeTier.hasFreight) {
                    basePriceToDisplay += " (+FRT)";
                  }

                  // Calculate discount percentage
                  if (activeTier.discountPercentage) {
                    discountPercentage = activeTier.discountPercentage;
                  }

                  console.log(
                    "getContext: basePriceToDisplay: ",
                    basePriceToDisplay
                  );
                  console.log(
                    "getContext: discountPercentage: ",
                    discountPercentage
                  );
                }
              }
              this.showPriceToDisplay = !!priceToDisplay;
              if (this.context === "PLP") {
                this.showPriceToDisplay = false;
              }
              this.showPriceToDisplay = true;
              var hasQtyPricing = !!(
                this.combinedPriceSchedule && this.combinedPriceSchedule.length
              );
              if (hasQtyPricing) {
                var html = "";
                html +=
                  '<select class="dc-cstm-quantity-pricing" data-action="qty-pricing-change" style="margin-top:0px;">';
                $.each(self.combinedPriceSchedule, function (index, item) {
                  var selected = index == self.selectedIndex ? "selected" : "";
                  html +=
                    '<option value="' +
                    index +
                    '" ' +
                    selected +
                    ">" +
                    item.display_text +
                    "</option>";
                });
                html += "</select>";
                // Append to the target element
                $(".quick-add-box-right-input").html("");
                $(".quick-add-box-right-input").append(html);
              }
            } else {
              this.model.unset("selectedProduct");
              this.$('[data-type="minimum-quantity"]').empty();
            }
          },
        });
        //
        if (pdp) {
          //hide native addToCart button from PDP
          _.extend(CartAddToCartButtonView.prototype, {
            // initialize: _.wrap(
            //   CartAddToCartButtonView.prototype.initialize,
            //   function (fn) {
            //     fn.apply(this, _.toArray(arguments).slice(1));
            //     this.showButton =
            //       arguments[1] && arguments[1].showButton ? true : false;
            //   }
            // ),

            // getContext: _.wrap(
            //   CartAddToCartButtonView.prototype.getContext,
            //   function (fn) {
            //     var context = fn.apply(this, _.toArray(arguments).slice(1));
            //     if (context.isCurrentItemPurchasable) {
            //       //hide button if from PDP, and display in modal
            //       context.isCurrentItemPurchasable = this.showButton;
            //     }
            //     return context;
            //   }
            // ),
          }); //END

          // pdp.on('beforeShowContent', function(){
          var iteminfo = pdp.getItemInfo();
          console.log("pdp", pdp.PDP_FULL_VIEW);

          _.extend(ProductDetailsFullView.prototype, {
            childViews: _.extend(
              {},
              ProductDetailsBaseView.prototype.childViews,
              {
                "Cstm.Quantity.Pricing": function () {
                  console.log("container", container);
                  return new QtyPriceView({
                    context: "PDP",
                    iteminfo: this.model.get("item"),
                    container: container,
                    model: this.model,
                  });
                },
              }
            ),

            // events: _.extend({}, ProductDetailsBaseView.prototype.events, {
              // 'Cstm.Quantity.Pricing': function() {
              // 	console.log('container', container);
              // 	return new QtyPriceView({
              // 		context: 'PDP', iteminfo: this.model.get('item'), container: container, model:this.model
              // 	});
              // }
              // 'click [data-action="show-confirmation"]':
              //   "showConfirmationModal",
            // }),

            // showConfirmationModal: function (e) {
            //   e.preventDefault();
            //   var confirmationView = new DCConfirmationView({
            //     // item: (this.context === 'PLP') ? this.contextData.item() : this.item,
            //     item: this.model.get("item"),
            //     selectedIndex: this.model.get("selectedIndex"),
            //     container: container,
            //     model: this.model,
            //     // hasRequiredFields: hasRequiredFields
            //   });
            //   this.model.validate();
            //   console.log(
            //     "all options selected",
            //     this.model.isSelectionComplete()
            //   );
            //   if (this.model.isValid()) {
            //     container
            //       .getComponent("Layout")
            //       .showContent(confirmationView, { showInModal: true });
            //   }
            // },
          });

          console.log(
            "ProductDetailsFullView.prototype.childViews",
            ProductDetailsFullView.prototype.childViews
          );
          // });
        }
        //for PLP
        if (plp) {
          layout.addToViewContextDefinition(
            "Cart.QuickAddToCart.View",
            "showQuickAddToCartButton",
            "boolean",
            function (context) {
              return false;
            }
          );

          // FacetsItemCellView.prototype.childViews = _.extend({}, FacetsItemCellView.prototype.childViews, {
          // })

          _.extend(FacetsItemCellView.prototype, {
            childViews: {
              "ItemViews.Stock": function () {
                return new ProductLineStockView({
                  model: this.model,
                });
              },

              "GlobalViews.StarRating": function () {
                var view = new GlobalViewsStarRating({
                  model: this.model,
                  showRatingCount: false,
                  queryOptions: Utils.parseUrlOptions(location.href),
                });

                return this.options.showStarRating === false ? null : view;
              },

              "ItemDetails.Options": function () {
                var options_configuration = Configuration.get(
                  "ItemOptions.optionsConfiguration",
                  []
                );

                return new BackboneCollectionView({
                  collection: _.filter(
                    this.model.get("options").sortBy("index"),
                    function (option) {
                      var option_configuration = _.findWhere(
                        options_configuration,
                        {
                          cartOptionId: option.get("cartOptionId"),
                        }
                      );
                      return (
                        option_configuration &&
                        option_configuration.showSelectorInList
                      );
                    }
                  ),
                  childView: ProductViewsOptionView,
                  viewsPerRow: 1,
                  childViewOptions: {
                    item: this.model,
                    templateName: "facetCell",
                    showLink: true,
                    hideLabel: true,
                    showSmall: true,
                  },
                });
              },

              "Cstm.Quantity.Pricing": function () {
                var product = new ProductModel({
                  item: this.model,
                  quantity: this.model.get("_minimumQuantity", true),
                });
                return new QtyPriceView({
                  context: "PLP",
                  container: container,
                  model: product,
                });
              },

              "Cart.QuickAddToCart": function () {
                var product = new ProductModel({
                  item: this.model,
                  quantity: this.model.get("_minimumQuantity", true),
                });

                console.log("=== QuickAddToCart on PLP DEBUG ===");
                console.log("product quantity:", product.get("quantity"));

                return new CartQuickAddToCartView({
                  model: product,
                  application: this.options.application,
                });
              },

              StockDescription: function () {
                return new ProductLineStockDescriptionView({
                  model: this.model,
                });
              },
            },
          });

          // plp.on('beforeShowContent', function(){
          // 	layout.registerView('Cstm.Quantity.Pricing', function() {
          // 		return new QtyPriceView({context: 'PLP', container: container});
          // 	});
          // });
        }
      }
    },
  };
});
